import { defaultColumns, defaultSort } from '../../components/data/shops/shops/columns';

export default {
  state: {
    shops: [],
    tableConfig: null,
    loading: false,
    currentPage: 1,
    filterString: null,
    sorting: {
      prop: 'name',
      order: 'ascending',
    },
  },
  getters: {
    shops: state => state.shops,
    tableConfig: state => state.tableConfig,
    loading: state => state.loading,
    sorting: state => state.sorting,
    filterString: state => state.filterString,
    currentPage: state => state.currentPage,
  },
  mutations: {
    setShops(state, shops) {
      state.shops = shops;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchTableConfig({ commit }) {
      try {
        const setting = await axios.get('api/table-settings/shop-list');
        if (setting.id) {
          const tableConfig = {
            id: setting.id,
            type: 'shop-list',
            columns: JSON.parse(setting.config).columns,
            sort: JSON.parse(setting.config).sort,
          };
          commit('setTableConfig', tableConfig);
        } else {
          const tableConfig = {
            type: 'shop-list',
            columns: defaultColumns,
            sort: defaultSort,
          };
          commit('setTableConfig', tableConfig);
        }
      } catch (e) {
      }
    },
    async fetchAll({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setCurrentPage', 1);
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const query = `?page=${state.currentPage}&sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&${state.filterString}`;
        const shops = await axios.get('api/shops-search' + (query || ''));
        commit('setShops', shops);
      } catch (e) {
        console.log(e);
      }
      commit('setLoading', false);
    },
    async search({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        return await axios.get('api/shops-search/name' + (queryString || ''));
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async excelExport({ commit }, { data, fileName, fileFormat }) {
      const excel = await axios({
        url: 'api/shop-excel-export',
        method: 'POST',
        responseType: 'blob',
        data,
      });
      saveAs(excel, `${fileName.trim().split(' ').join('_') || 'Shops'}.${fileFormat.toLocaleLowerCase() || 'xlsx'}`);
    },
    async fetch({ commit }, id) {
      return await axios.get(`api/shops-search/${id}`);
    },
    async create({ commit }, payLoad) {
      await axios.post('api/shops', payLoad);
    },
    async update({ commit }, payLoad) {
      await axios.put('api/shops', payLoad);
    },
    async delete({ commit }, id) {
      await axios.delete(`api/shops/${id}`);
    },
  },
};
